import ApplicationController from './application_controller'
import { useSelect } from './mixins'

export default class extends ApplicationController {
  static targets = [
    "select",
    "selectContainer",
    "nameInput",
    "percentageAlcoholInput",
    "styleInput",
    "ibusInput",
    "technicalDescriptionInput",
    "itemName",
    "itemImageUrl",
    "itemDescription",
    "itemStyle",
    "itemAlcoholByVolume",
    "itemIbus",
    "itemUntappdBreweryId",
    "itemBreweryName"
  ]

  connect() {
    super.connect()

    useSelect(this)

    if (this.hasSelectTarget) {
      this.initializeChoices()
      this.connectChoices()
    }
  }

  onUntappdProductChange(event) {
    const selectElement = event.target
    const selectedOption = selectElement.options[selectElement.selectedIndex]

    if (selectedOption) {
      if (this.hasNameInputTarget && !this.nameInputTarget.value) {
        this.nameInputTarget.value = selectedOption.dataset.name
      }

      if (!this.percentageAlcoholInputTarget.value) {
        this.percentageAlcoholInputTarget.value = selectedOption.dataset.alcoholByVolume
      }

      if (!this.styleInputTarget.value) {
        const styleValue = selectedOption.dataset.style

        if (styleValue) {
          const selectComponentController = this.application.getControllerForElementAndIdentifier(
            this.styleInputTarget.closest('[data-controller~="select-component"]'),
            'select-component'
          )

          if (selectComponentController && selectComponentController.choices) {
            const styleChoices = selectComponentController.choices

            const existingChoice = styleChoices._currentState.choices.find(
              choice => choice.value === styleValue
            )

            if (!existingChoice) {
              styleChoices.setChoices(
                [{ value: styleValue, label: styleValue, selected: false }],
                'value',
                'label',
                false
              )
            }
            styleChoices.setChoiceByValue(styleValue)
          }
        }
      }

      if (!this.ibusInputTarget.value) {
        this.ibusInputTarget.value = selectedOption.dataset.ibus
      }

      if (!this.technicalDescriptionInputTarget.value) {
        this.technicalDescriptionInputTarget.value = selectedOption.dataset.description
      }

      this.itemNameTarget.value = selectedOption.dataset.name
      this.itemImageUrlTarget.value = selectedOption.dataset.imageUrl
      this.itemDescriptionTarget.value = selectedOption.dataset.description
      this.itemStyleTarget.value = selectedOption.dataset.style
      this.itemAlcoholByVolumeTarget.value = selectedOption.dataset.alcoholByVolume
      this.itemIbusTarget.value = selectedOption.dataset.ibus
      this.itemUntappdBreweryIdTarget.value = selectedOption.dataset.untappdBreweryId
      this.itemBreweryNameTarget.value = selectedOption.dataset.breweryName
    }
  }
}